// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { RelayPayload } from './relayPayload.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class RelayRelayListenerRelayEvent {
    'event_id': string;
    'event_name': string;
    'event_ts': string;
    'payload': RelayPayload | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof RelayRelayListenerRelayEvent>> = [
        {
            "name":     "event_id",
            "baseName": "event_id",
            "type":     "string"
        },
        {
            "name":     "event_name",
            "baseName": "event_name",
            "type":     "string"
        },
        {
            "name":     "event_ts",
            "baseName": "event_ts",
            "type":     "string"
        },
        {
            "name":     "payload",
            "baseName": "payload",
            "type":     "RelayPayload"
        },
    ];

    static getAttributeTypeMap() {
        return RelayRelayListenerRelayEvent.attributeTypeMap;
    }
}
